const policy = [
    {
        name: "Miễn phí giao hàng",
        description: "Miễn phí ship với",
        highlight: " đơn hàng > 239K",
        icon: "fa-brands fa-opencart"
    },
    {
        name: "Thanh toán COD",
        description: "Thanh toán khi",
        highlight: " nhận hàng (COD)",
        icon: "fa-solid fa-truck-fast"
    },
    {
        name: "Khách hàng VIP",
        description: "Ưu đãi dành cho",
        highlight: " khách hàng VIP",
        icon: "fa-solid fa-gem"
    },
    {
        name: "Hỗ trợ bảo hành",
        description: "Bảo hành sản phẩm tại",
        highlight: " tất cả store",
        icon: "fa-solid fa-shield"
    }
]

export default policy